module.exports = __webpack_public_path__ + "img/a32.12bcfb3c.svg";